import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Container, useTheme } from '@mui/material';
import { Lock, Home, ArrowBack } from '@mui/icons-material';
import LogoSVG from './common/LogoSVG';

function Forbidden() {
  const navigate = useNavigate();
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `linear-gradient(135deg, ${theme.palette.error.main}10 0%, ${theme.palette.warning.main}10 100%)`,
        position: 'relative',
      }}
    >
      <Container maxWidth="md">
        <Box textAlign="center">
          <Box sx={{ mb: 4 }}>
            <LogoSVG width={200} height={60} />
          </Box>

          <Box
            sx={{
              fontSize: '120px',
              color: theme.palette.error.main,
              mb: 2,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <Lock sx={{ fontSize: 'inherit' }} />
          </Box>

          <Typography variant="h1" sx={{ fontSize: '72px', fontWeight: 800, mb: 2, color: theme.palette.error.main }}>
            403
          </Typography>

          <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
            Access Forbidden
          </Typography>

          <Typography variant="h6" sx={{ mb: 4, color: theme.palette.text.secondary, maxWidth: '600px', mx: 'auto' }}>
            You don't have permission to access this area. If you believe this is a mistake, please contact your administrator.
          </Typography>

          <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center' }}>
            <Button
              variant="contained"
              size="large"
              startIcon={<Home />}
              onClick={() => navigate('/dashboard')}
              sx={{ px: 4, py: 1.5 }}
            >
              Go to Dashboard
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBack />}
              onClick={() => navigate(-1)}
              sx={{ px: 4, py: 1.5 }}
            >
              Go Back
            </Button>
          </Box>
        </Box>
      </Container>
    </Box>
  );
}

export default Forbidden;
